// 应用范例菜单组件

import { Collapse, Menu, message } from 'antd';
import { useState, useEffect } from 'react'
import { ToolOutlined, AppstoreAddOutlined, HistoryOutlined } from '@ant-design/icons';
import fun from '../../common/common_fun'
import url from '../../common/url_config'
import cookie from 'react-cookies'

const { SubMenu } = Menu
const { Panel } = Collapse

function App(props: any) {
  let EVK: any = [], POC: any = []
  let [loading, set_loading] = useState(false)//加载中
  let [menu_data, set_menu_data] = useState([])//恩智浦内部开发板菜单数据
  let temp: any = []
  let [default_active_key, set_default_active_key] = useState(temp)//
  let [current_language_ch, set_current_language_ch] = useState(window.location.href.indexOf('?lan=en') === -1)//当前语言是否中文


  useEffect(() => {
    let current_page_type = props.current_page_type
    if (current_page_type) {
      if (current_page_type === 'i.MX 产品应用范例') {
        set_default_active_key(['0'])
      }
      if (current_page_type === 'MCU产品应用范例') {
        set_default_active_key(['1'])
      }
      if (current_page_type === '合作伙伴产品应用范例') {
        set_default_active_key(['2'])
      }
    } else {
      set_default_active_key(['0', '1', '2'])
    }
    console.log(current_page_type)

    set_loading(true)
    fun['post_data'](url + 'get_user_case', { 'page_type': '应用范例', '是否显示': '显示' }).then(res => {
      if (res.status) {
        // console.log('查询分类数据', res.result)
        let rows = res.result.map((item: any) => {
          let children_by_type: any = []//案例分类
          let children_by_type_en: any = []//案例分类英文
          let children_by_type_set: any = []//将案例分类后的use-case
          for (let i in item.children) {
            if (children_by_type.indexOf(item.children[i]['案例分类']) === -1) {
              children_by_type.push(item.children[i]['案例分类'])
              children_by_type_en.push(item.children[i]['案例分类英文'])
            }
          }
          for (let i in children_by_type) {
            let children: any = []
            for (let j in item.children) {
              if (item.children[j]['案例分类'] === children_by_type[i]) {
                children.push(item.children[j])
              }
            }
            children_by_type_set.push({ name_ch: children_by_type[i], name_en: children_by_type_en[i], children })
          }
          return ({ ...item, children_by_type, children_by_type_set })
        })
        // console.log(rows)

        set_menu_data(rows)
      } else {
        message.error(JSON.stringify(current_language_ch ? res.result : (res.result_en || res.result)))
      }
      set_loading(false)
    })
  }, [])

  return (
    <div className='collapse_box'>
      {default_active_key.length > 0 && <Collapse defaultActiveKey={default_active_key}>
        {menu_data.map((item: any, index: number) => <Panel key={String(index)} header={<a href={'/use-case-show/' + item.url_id + (current_language_ch ? '' : '?lan=en')} style={{ fontFamily: 'PoppinsBold', fontWeight: 'bold' }}>{current_language_ch ? item['栏目中文名称'] : item['栏目英文名称']}</a>}>
          <Collapse defaultActiveKey={['0', '1', '2', '3', '4', '5', '6']}>
            {item.children_by_type_set.map((item2: any, index2: number) => <Panel key={String(index2)} header={current_language_ch ? item2.name_ch : item2.name_en}>
              {item2.children.map((item3: any, index3: number) => <a style={{ borderTop: index3 === 0 ? 'none' : '1px solid rgb(226, 226, 226)' }} title={current_language_ch ? item3['标题中文'] : item3['标题英文']} target={item3.href_url ? '_blank' : '_self'} href={item3.href_url ? ('/article/' + item3.href_url + (current_language_ch ? '' : '-en')) : ('/use-case-show/' + item.url_id + (current_language_ch ? '' : '?lan=en') + '#' + item3['url_id'])} className='menu_children_use_case' key={String(index3)}>
                {current_language_ch ? item3['标题中文'] : item3['标题英文']}
              </a>)}
            </Panel>)}
          </Collapse>
        </Panel>)}
      </Collapse>}
    </div >
  )
}

export default App